import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Checkbox, Paper, Tooltip, Typography} from "@mui/material";
import {Delete} from "@mui/icons-material";
import MaterialPriceUnitService from "../../../../../../API/orders/warehouse/MaterialPriceUnitService";
import PriceWithCurrency from "../PriceWithCurrency";
import MaterialWarehouseService from "../../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import FilterUtil from "../../../../../../utils/common/FilterUtil";
import CellCheckboxWithUnable from "../../../../сheckbox/CellCheckboxWithUnable";
import CellCheckbox from "../../../../сheckbox/CellCheckbox";
import {materialWarehouseStatuses} from "../../../../../../data/MaterialWarehouseState";
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ModalCreateCutOff from "./ModalCreateCutOff";
import ModalSetTrimming from "./ModalSetTrimming";
import MaterialPriceUnitUtil from "../../../../../../utils/warehouse/MaterialPriceUnitUtil";
import {Link} from "react-router-dom";
import ButtonSelectAction from "../../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../modal/ModalSelectAction";
import ButtonCreate from "../../../../button/ButtonCreate";
import selectionTableUtil, {normalizeSelection} from "../../../../../../utils/common/SelectionTableUtil";
import MenuItem from "@mui/material/MenuItem";
import ModalAddWarehouseMaterial from "./ModalAddWarehouseMaterial";
import UtilityService from "../../../../../../API/common/UtilityService";
import {materialEstimateUnitStates} from "../../../../../../data/MaterialEstimateUnitState";

/** Складская позиция «В наличии» с нулевым остатком — в раскрой не берём. */
const isZeroStockInWarehouse = (row) =>
    row?.materialWarehouseState === "IN_STOCK" && !(Number(row.quantity) > 0);

const MaterialWarehouseTable = ({
                                    nameMaterial,
                                    isPriceInCurrencyArrival,
                                    isPriceInCurrencyBase,
                                    isPriceInCurrencyAlternative,
                                    isWarehouse,
                                    isPlace,
                                    baseIndents,
                                    tempBaseIndents,
                                    setTempBaseIndents,
                                    data,
                                    setData,
                                    unableCut,
                                    setUnableCut,
                                    isAddCutOffButton,
                                    isActions,
                                    isColumnCut,
                                    isColumnReserve,
                                    baseCurrency,
                                    alternativeCurrency,
                                    selectMaterial,
                                    material,
                                    handleModalAlert
                                }) => {

        const [open, setOpen] = useState(false)
        const [materialWarehouseData, setMaterialWarehouseData] = useState(null);
        const [materialPriceUnitData, setMaterialPriceUnitData] = useState(null);
        const [openModalCreateCutOff, setOpenModalCreateCutOff] = useState(false);
        const [openModalSetTrimming, setOpenModalSetTrimming] = useState(false);

        const [supplierMaterials, setSupplierMaterials] = useState()
        const [dataSuppliers, setDataSuppliers] = useState()

        const [rowSelection, setRowSelection] = useState([]);
        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
        const currentSelection = normalizeSelection(rowSelection)

        const [currencyMap, setCurrencyMap] = useState(new Map);
        const [loading, setLoading] = useState(false)

        useEffect(() => {
            UtilityService.getCurrencies()
                .then(function (response) {
                    const data = response.data;
                    data.forEach((c) => {
                        currencyMap.set(c.id, c);
                    });
                }).catch(function (error) {
                handleModalAlert(error)
            })
        }, []);

        const handleUnableCheckboxCut = (id, status) => {
            const materialPriceUnitId = MaterialPriceUnitUtil.getMaterialPriceUnitIdById(id, data);
            MaterialPriceUnitService.unableCut(materialPriceUnitId, status).then(function () {
                handleUnableCut(id, status)
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        };

        const handleUnableCut = (id, status) => {
            unableCut[id] = status
            setUnableCut(prevState => ({
                ...prevState,
                [id]: status
            }));
        };

        const handleAddCutOff = () => {

            const materialPriceUnit = {
                length: 2800,
                width: 0,
                quantity: 0,
                cut: true,
                cutOff: true,
                trimmingLeft: 20,
                trimmingRight: 20,
                trimmingTop: 20,
                trimmingBottom: 20,
            }

            const materialWarehouse = {
                quantity: 0,
                inReserve: 0,
                materialWarehouseState: "PLANNED",
                materialPriceUnit: null,
                accountOverallBudget: false
            };

            setMaterialPriceUnitData(materialPriceUnit);
            setMaterialWarehouseData(materialWarehouse);
            setOpenModalCreateCutOff(true);
        };


        const handleCloseEditTrimming = () => {
            setTempBaseIndents(baseIndents)
            setOpenModalSetTrimming(false);
        }

        const handleSubmitEditTrimming = () => {
            setLoading(true)
            const selectedMaterialPriceUnitIds = rowSelection
                .map((rowId) => data.find((item) => item.id === rowId)?.materialPriceUnit?.id)
                .filter((id) => id !== undefined && id !== null);

            MaterialPriceUnitService.updateTrimmingByIds(selectedMaterialPriceUnitIds,
                tempBaseIndents.trimmingLeft, tempBaseIndents.trimmingRight, tempBaseIndents.trimmingTop,
                tempBaseIndents.trimmingBottom)
                .then(function () {
                    setData(data.map(el => {
                        if (rowSelection.includes(el.id)) {
                            return {
                                ...el,
                                materialPriceUnit: {
                                    ...el.materialPriceUnit,
                                    trimmingLeft: tempBaseIndents.trimmingLeft,
                                    trimmingRight: tempBaseIndents.trimmingRight,
                                    trimmingTop: tempBaseIndents.trimmingTop,
                                    trimmingBottom: tempBaseIndents.trimmingBottom,
                                }
                            }
                        } else {
                            return el
                        }
                    }))
                    handleCloseEditTrimming();
                    setRowSelection([])
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setLoading(false))
        }


        const handleSubmitCreateCutOff = (data, reset) => {
            setLoading(true)
            const materialWarehouseData = {
                materialPriceUnit: data.materialPriceUnit,
                note: data.note
            }
            const supplierMaterialId = data.supplierMaterialId;

            MaterialWarehouseService.createPlanned(materialWarehouseData, nameMaterial, supplierMaterialId).then(function (response) {
                const responseData = response.data;
                handleCreateNewRow(responseData)
                reset();
                handleModalAlert("Плановая закупка добавлена", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setLoading(false))
        }

        const handleCloseCreateCutOff = () => {
            setMaterialWarehouseData(null);
            setOpenModalCreateCutOff(false);
        };

        const handleCreateNewRow = (values) => {
            data.push(values);
            setData([...data]);
        };

        const handleDeleteRow = useCallback(
            (row) => {
                // Как на /organization/materials/... — DELETE .../delete-planned/{materialWarehouseId}
                MaterialWarehouseService.deletePlanned(row.id)
                    .then(function () {
                        setData((prev) => prev.filter((el) => el.id !== row.id));
                        handleModalAlert("Данные удалены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
            },
            [handleModalAlert, setData],
        );

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'cutOff',
                    header: 'Обрезок',
                    accessorKey: 'materialPriceUnit.cutOff',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <Checkbox
                        checked={row.original.materialPriceUnit.cutOff}
                        disabled={true}
                        sx={{'& .MuiSvgIcon-root': {fontSize: 22}}}
                    />
                },
                {
                    id: 'length',
                    header: 'W',
                    accessorKey: 'materialPriceUnit.length',
                    size: 80,
                },
                {
                    id: 'width',
                    header: 'H',
                    accessorKey: 'materialPriceUnit.width',
                    size: 80,
                },
                {
                    id: 'trimming',
                    header: 'Отступы',
                    accessorKey: 'materialPriceUnit.trimmingLeft',
                    size: 100,
                    Cell: ({row}) => row.original.materialPriceUnit.cutOff ? '['
                        + row.original.materialPriceUnit.trimmingLeft + ', '
                        + row.original.materialPriceUnit.trimmingRight + ', '
                        + row.original.materialPriceUnit.trimmingTop + ', '
                        + row.original.materialPriceUnit.trimmingBottom + ']' : '',
                },
                {
                    id: 'materialPriceUnit.quantity',
                    header: 'Кол.',
                    accessorKey: 'materialPriceUnit.quantity',
                    size: 80,
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                    },
                },
                {
                    id: 'quantity',
                    header: 'Наличие.',
                    accessorKey: 'quantity',
                    size: 80,
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                    },
                },
                {
                    id: 'materialWarehouseState',
                    header: 'Статус',
                    accessorKey: 'materialWarehouseState',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell}) => materialWarehouseStatuses[cell.getValue()],
                    filterFn: (row, id, filterValue) => {
                        return materialWarehouseStatuses[row.original.materialWarehouseState].toLowerCase().includes(filterValue.toLowerCase())
                    },
                },
                {
                    id: 'note',
                    header: 'Комментарий',
                    accessorFn: (row) => row.note ?? '',
                    size: 8,
                    maxSize: 8,
                    filterFn: (row, id, filterValue) => {
                        return (row.original.note || '').toLowerCase().includes((filterValue || '').toLowerCase())
                    },
                },
                {
                    header: 'id',
                    id: 'id',
                    accessorKey: 'id',
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                    enableHiding: false,
                },
            ];

            if (isColumnCut) {
                baseColumns.splice(1, 0, {
                    id: 'cut',
                    header: 'H',
                    Header: () => (<div>
                        <ContentCutIcon sx={{padding: 0, fontSize: '15px', marginTop: '6px'}}/>
                    </div>),
                    accessorKey: 'materialPriceUnit.cut',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckboxWithUnable
                        id={row.id}
                        unable={unableCut}
                        setUnable={handleUnableCheckboxCut}
                        disabled={
                            !row.original.materialPriceUnit.cutOff
                            || isZeroStockInWarehouse(row.original)
                        }
                    >
                    </CellCheckboxWithUnable>,
                });
            }

            if (isColumnCut) {
                baseColumns.splice(8, 0, {
                    id: 'workingCuttingMap.number',
                    header: 'К. раскроя',
                    accessorKey: 'workingCuttingMap.number',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => (
                        cell.getValue() ? (
                            <Link
                                to={'/organization/working-cutting-map/' + row.original.workingCuttingMap?.id + '/' + encodeURIComponent(nameMaterial) + "/" + encodeURIComponent(row.original.workingCuttingMap?.number) + "/" + row.original.workingCuttingMap?.materialOId}>
                                {cell.getValue()}
                            </Link>
                        ) : ''
                    ),
                });
            }

            if (isColumnReserve) {
                baseColumns.splice(7, 0, {
                    id: 'inReserve',
                    header: 'Резерв',
                    accessorKey: 'inReserve',
                    size: 8,
                    maxSize: 8,
                });
            }

            if (isPriceInCurrencyArrival) {
                baseColumns.splice(9, 0, {
                    id: 'PriceInCurrencyArrival',
                    header: 'Цена в валюте прихода',
                    accessorKey: 'materialPriceUnit.materialPriceInCurrencyArrival.price',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                    Cell: ({cell, row}) => row.original.materialPriceUnit.materialPriceInCurrencyArrival === null ? '' :
                        <PriceWithCurrency cell={cell}
                                           row={row}
                                           currencyMap={currencyMap}
                        />,
                });
            }
            if (isPriceInCurrencyBase) {
                baseColumns.splice(10, 0, {
                    id: 'PriceInCurrencyBase',
                    header: `Цена в ${baseCurrency}`,
                    accessorKey: 'materialPriceUnit.materialPriceInCurrencyBase.price',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                    Cell: ({
                               cell,
                               row
                           }) => row.original.materialPriceUnit.materialPriceInCurrencyBase === null ? '' : cell.getValue(),
                });
            }
            if (isPriceInCurrencyAlternative) {
                baseColumns.splice(11, 0, {
                    id: 'PriceInCurrencyAlternative',
                    header: `Цена в ${alternativeCurrency}`,
                    accessorKey: 'materialPriceUnit.materialPriceInCurrencyAlternative.price',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                    Cell: ({
                               cell,
                               row
                           }) => row.original.materialPriceUnit.materialPriceInCurrencyAlternative === null ? '' : cell.getValue(),
                });

            }
            if (isWarehouse) {
                baseColumns.splice(12, 0, {
                    id: 'warehouse.name',
                    header: 'Склад',
                    accessorKey: 'warehouse.name',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                    Cell: ({cell, row}) => row.original.warehouse === null ? '' : cell.getValue(),
                });
            }

            if (isPlace) {
                baseColumns.splice(13, 0, {
                    id: 'place',
                    header: 'Место',
                    accessorKey: 'warehouse.name',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                });
            }

            return baseColumns;

        }, [data, setData]);

        const modalActions = [
            {name: "Установть оступы обрезков", type: "setTrim"},
        ]
        const setIndents = () => {
            setTempBaseIndents(baseIndents);
            if (rowSelection.length === 1) {
                const mWH = data.find((item) => item.id === rowSelection[0]);
                if (!mWH?.materialPriceUnit) {
                    handleModalAlert("Не удалось получить данные выбранной позиции");
                    return;
                }
                tempBaseIndents.trimmingLeft = mWH.materialPriceUnit.trimmingLeft
                tempBaseIndents.trimmingRight = mWH.materialPriceUnit.trimmingRight
                tempBaseIndents.trimmingTop = mWH.materialPriceUnit.trimmingTop
                tempBaseIndents.trimmingBottom = mWH.materialPriceUnit.trimmingBottom
                setTempBaseIndents(tempBaseIndents);
            }
            setOpenModalSetTrimming(true)
            setOpen(false)
        }
        const menuItem = [
            {type: "delete", text: "Удалить", handler: handleDeleteRow}
        ]
        return (
            <Box sx={{maxWidth: "2500px"}}>
                <Box
                    sx={{display: 'flex', justifyContent: "space-between", gap: "10px", paddingBottom: "30px"}}
                >
                    <Typography>{nameMaterial}</Typography>
                    <ButtonCreate
                        text={"Добавить плановый"}
                        width={220}
                        onClick={handleAddCutOff}
                    />
                </Box>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableBodyCellProps={({cell, table}) => {
                        return ({
                            sx: () => ({
                                    p: (cell.column.id === "cutOff" || cell.column.id === "cut") ? 0 : '0px 0px 0px 10px',
                                    m: '0px 0px 0px 0px',
                                    border: "none",
                                    textAlign: cell.column.id === "cutOff" ? "center" : "left",
                                    "&:after": {
                                        display: "none",
                                    },
                                    "&:not(:last-of-type)": {
                                        borderRight: '1px solid #EAEBEA',

                                    },
                                    "&:first-of-type": {
                                        padding: 0,
                                        width: "50px",
                                        height: "36px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: (theme) => theme.palette.text.light,
                                        "& .MuiButtonBase-root": {
                                            borderRadius: "4px",
                                            width: "24px",
                                            height: "24px",
                                            opacity: 1,
                                            margin: 0,
                                            padding: 0,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.stroke,
                                            }
                                        }
                                    },
                                    "& a": {
                                        color: "#006CCC",
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "underline"
                                        }

                                    }
                                }
                            )
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                    }}
                    columns={columns}
                    data={data}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 50},
                        sorting: [
                            {
                                id: 'materialWarehouseState',
                                desc: false,
                            },]
                    }}
                    enableToolbarInternalActions={false}
                    enableRowActions={true}
                    onRowSelectionChange={onRowSelectionChange}
                    state={{rowSelection: currentSelection, showGlobalFilter: true}}
                    enableRowSelection={(row) =>
                        row.original.materialPriceUnit.cutOff
                        && !isZeroStockInWarehouse(row.original)
                    }
                    getRowId={(originalRow) => originalRow.id}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        const available = row.original.materialPriceUnit.cutOff && row.original.materialWarehouseState === 'PLANNED'
                        return <MenuItem
                            key={el.type}
                            disabled={!available}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}

                    localization={MRT_Localization_RU}

                    muiTableContainerProps={{
                        sx: {
                            maxHeight: `calc(100vh - 710px)`,
                            width: "2500px"
                        }
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                                "& .MuiBox-root": {
                                    padding: "5px"
                                }
                            },

                        }
                    }}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={setIndents}
                    modalActions={modalActions}
                />
                <ModalSetTrimming
                    open={openModalSetTrimming}
                    onClose={handleCloseEditTrimming}
                    title={'Редактировать отсупы'}
                    values={tempBaseIndents}
                    setValues={setTempBaseIndents}
                    labelButtonSSubmit={'Установить'}
                    handleSubmit={handleSubmitEditTrimming}
                    loading={loading}
                />
                {openModalCreateCutOff && baseCurrency !== null && alternativeCurrency !== null &&
                    baseCurrency !== null && alternativeCurrency !== null
                    && <ModalAddWarehouseMaterial
                        title={"Добавить плановую закупку материала"}
                        buttonName={"Добавить"}
                        open={openModalCreateCutOff}
                        onClose={handleCloseCreateCutOff}
                        materialId={material.id}
                        materialWidth={material.width}
                        supplierMaterials={supplierMaterials}
                        setSupplierMaterials={setSupplierMaterials}
                        dataSuppliers={dataSuppliers}
                        setDataSuppliers={setDataSuppliers}
                        baseCurrency={baseCurrency}
                        alternativeCurrency={alternativeCurrency}
                        handleSubmitCreate={handleSubmitCreateCutOff}
                        currencyMap={currencyMap}
                        handleModalAlert={handleModalAlert}
                        loading={loading}
                    />}
            </Box>
        );
    }
;

export default MaterialWarehouseTable;